import React from 'react';
import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {Image, ImageProps} from "../image/image";
import {BaseMetadataModel} from "../../../infrastructure/models/base-metadata-model";
import {EntityLogoComposer} from "./entity-logo-composer";
import {ImageRequestParams} from "../../../infrastructure/models/params/image-request-params";
import {BaseProps} from "../../../infrastructure/models/props/base-props";

export class EntityLogoProps extends BaseProps {
  entity: EntityViewModel;
  metadata: BaseMetadataModel;
  style: Object;
  width: Number;
  height: Number;
  isLight: Boolean;
  eager: Boolean;
  onLoad: Function;
  fallbackImage: String;
  onError: Function;
  className: String;
  theme: String;
  src: ImageRequestParams
}

export const EntityLogo = EntityLogoComposer(({style, width, height, theme, src, eager, className, onLoad, onError, alt}: EntityLogoProps) => {
  const newStyle = {...style};

  !newStyle.maxWidth && (newStyle.maxWidth = width || style?.width);
  !newStyle.maxHeight && (newStyle.maxHeight = height || style?.height);
  newStyle.width = 'auto';
  newStyle.height = 'auto';

  const imageProps: ImageProps = {
    src,
    style: newStyle,
    eager,
    className,
    onLoad: () => onLoad && onLoad(),
    onError: () => onError && onError(),
    width,
    height,
    theme,
    alt
  }

  return <Image {...imageProps}/>;
});
